import React, { useEffect, useState } from "react";
import { Grid, Button, withStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
const styles = () => ({
  mainContainer: {
    width: "93%",
    margin: "0 auto",
    boxShadow: "0 10px 15px rgba(0,0,0,0.04)",
    gap: "1%",
    border: "1px solid rgba(0,0,0,0.04)",
    padding: "10px 20px",
  },
  uploadContainer: {
    '& div[role="button"]': {
      height: "150px !important",
      margin: "0px 10px !important",
    },
  },
  fieldContaienr: {
    maxWidth: "23%",
  },
  familyCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "18px",
    fontWeight: "700",
    paddingBottom: "20px",
  },
  editBtn: {
    border: "1px solid black",
  },
  saveBtn: {
    border: "1px solid black",
  },
});
const FamilyDetails = ({
  classes,
  loanApplicationId,
  existingLoanData,
  editable,
  mobileNum,
  getEmptyMember,
  familyList,
  setFamilyList,
  getFamilyDetailsData
}) => {
  const { authToken } = useSelector((state) => state.login.authData);

  const [callInProgress, setCallInProgress] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [borrowList, setBorrowList] = useState([]);

  const [toast, setToast] = useState(false); // keep only for NEXT validation
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const fetchFamily = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: `${endpoint.FAMILY_DETAIL_BASE_URL}/${loanApplicationId}/find`,
      method: "GET",
      authToken,
    });
    setCallInProgress(false);

    if (res?.data?.length > 0) {
      const updated = [getEmptyMember(), getEmptyMember()];
      res.data.forEach((item, index) => {
        if (index < 2) {
          updated[index] = {
            ...getEmptyMember(),
            name: item?.name,
            relationship: item?.relationship?.toUpperCase(),
            mobileNumber: item?.mobileNumber,
            income: item?.income,
            id: item?.id,
            isLocked: true,
          };
        }
      });

      setFamilyList(updated);
    } else {
      if (existingLoanData?.familyDetails?.length > 0) {
        const updated = [getEmptyMember(), getEmptyMember()];
        existingLoanData?.familyDetails?.forEach((item, index) => {
          if (index < 2) {
            updated[index] = {
              ...getEmptyMember(),
              name: item?.name,
              relationship: item?.relationship?.toUpperCase(),
              mobileNumber: item?.mobileNumber,
              income: item?.income,
              id: item?.id,
              isLocked: false,
            };
          }
        });
        setFamilyList(updated);
      } else {
        GetExistingFamilyDetails();
      }
    }
  };

  const GetExistingFamilyDetails = async () => {
     const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNum,
      method: "GET",
      authToken,
    });
    if (res?.data?.[0]?.familyDetails?.length > 0) {
      const updated = [getEmptyMember(), getEmptyMember()];
      res?.data?.[0]?.familyDetails?.forEach((item, index) => {
        if (index < 2) {
          updated[index] = {
            ...getEmptyMember(),
            name: item?.name,
            relationship: item?.relationship?.toUpperCase(),
            mobileNumber: item?.mobileNumber,
            income: item?.income,
            id: item?.id,
            isLocked: false,
          };
        }
      });
      setFamilyList(updated);
    }
  };

  const GetRelationship = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.RELATIONSHIP_FINDALL,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.length) {
      setBorrowList(res?.data);
    }
  };

  useEffect(() => {
    fetchFamily();
    GetRelationship();
  }, []);

  const handleChange = (index, field, value) => {
    const regex = /^[0-9\b]+$/;
    if (field === "mobileNumber" || field === "income") {
      if (value !== "" && !regex.test(value)) return;
    }
    const updated = [...familyList];
    if (field === "relationship") {
      updated[index][field] = value?.relationshipName || value;
    } else {
      updated[index][field] = value;
    }
    updated[index].errors[field] = false;
    setFamilyList(updated);
  };
  const validateMemberIncome = (currentIncome, currentIndex) => {
    const allocatedAmount = familyList
      .filter((_, index) => index !== currentIndex)
      .reduce((sum, item) => {
        return item.isLocked
          ? sum + Number(item.income || 0)
          : sum;
      }, 0);

    const remainingAmount =
      Number(getFamilyDetailsData?.[0]?.additionalIncome) - allocatedAmount;

    if (Number(currentIncome) > remainingAmount) {
      toastUpdate(
        "Error",
        `Income amount cannot be greater than remaining settlement amount (${remainingAmount})`,
        true
      );
      return false;
    }

    return true;
  };
  const handleSave = async (index) => {
    const data = familyList[index];
    const updated = [...familyList];
    const errors = {
      name: !data.name?.trim(),
      relationship: !data.relationship?.trim(),
      mobileNumber:
        !data.mobileNumber?.trim() || data.mobileNumber.length !== 10,
      income: !data.income || Number(data.income) <= 0,
    };

    updated[index].errors = errors;
    setFamilyList(updated);

    if (Object.values(errors).some(Boolean)) return;
    if (!validateMemberIncome(data.income, index)) {
      return;
    }
    const payload = {
      name: data.name,
      relationship: data.relationship,
      mobileNumber: data.mobileNumber,
      income: data.income,
    };
    setLoadingIndex(index);
    try {
      if (data.id) {
        // UPDATE
        setCallInProgress(true);
        await apiHandler({
          url: `${endpoint.FAMILY_DETAIL_BASE_URL}/${loanApplicationId}/update/${data.id}`,
          method: "POST",
          authToken,
          data: payload,
        });
        setCallInProgress(false);
      } else {
        // CREATE
        setCallInProgress(true);
        const res = await apiHandler({
          url: `${endpoint.FAMILY_DETAIL_BASE_URL}/${loanApplicationId}/create`,
          method: "POST",
          authToken,
          data: payload,
        });
        setCallInProgress(false);
        updated[index].id = res?.data?.id;
      }

      updated[index].isLocked = true;
      setFamilyList(updated);
    } catch (e) {
      console.error(e);
    }
    setLoadingIndex(null);
  };
  const handleDelete = async (index)=>{    
    const result = await apiHandler({
        url: `${endpoint.FAMILY_DETAIL_BASE_URL}/${loanApplicationId}/delete/${familyList[index].id}` ,
        authToken: authToken,
        method: "DELETE",
      });
    await fetchFamily()
  }
  //  EDIT
  const handleEdit = (index) => {
    const updated = [...familyList];
    updated[index].isLocked = false;
    setFamilyList(updated);
  };



  return (
    <Grid container spacing={3}>
      {/* <LoanDetailsPurpose/>
      <InflowDetails/>
      <Outflow/> */}
      <Grid container spacing={3} className={classes.mainContainer}>
        <SubHeader label="Family Details" onlyLabel />
        {familyList.map((member, index) => (
          <Grid item xs={12} key={index}>
            <div className={classes.familyCard}>
              {/* Header */}
              <div className={classes.familyCardHeader}>
                <div className={classes.familyTitle}>
                  Family Member {index + 1}
                </div>

                {editable && (
                  <>
                    {member.isLocked ? (
                      <div>
                      <Button
                        size="small"
                        onClick={() => handleEdit(index)}
                        className={classes.editBtn}
                        style={{marginRight:'20px'}}
                      >
                        Edit
                      </Button>
                          <Button
                        size="small"
                        onClick={() => handleDelete(index)}
                        className={classes.editBtn}
                      >
                        Delete
                      </Button>
                      </div>
                    ) : (
                      <Button
                        size="small"
                        color="primary"
                        disabled={loadingIndex === index}
                        onClick={() => handleSave(index)}
                        className={classes.saveBtn}
                      >
                        Save
                      </Button>
                    )}
                  </>
                )}
              </div>

              {/* Fields */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <CustomeTextField
                    label="Name"
                    value={member.name}
                    error={member.errors.name}
                    disabled={member.isLocked || !editable}
                    setState={(val) => handleChange(index, "name", val)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <CustomeSelectNew
                    label="Relationship*"
                    value={member.relationship}
                    error={member.errors.relationship}
                    setState={(val) => handleChange(index, "relationship", val)}
                    data={borrowList}
                    disabled={member.isLocked || !editable}
                    type="relationshipname"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <CustomeTextField
                    label="Mobile"
                    value={member.mobileNumber}
                    error={member.errors.mobileNumber}
                    maxLength="10"
                    disabled={member.isLocked || !editable}
                    setState={(val) => handleChange(index, "mobileNumber", val)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <CustomeTextField
                    label="Income"
                    value={member.income}
                    error={member.errors.income}
                    disabled={member.isLocked || !editable}
                    setState={(val) => handleChange(index, "income", val)}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
        ))}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}

        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(FamilyDetails);
